export default "__VITE_ASSET__DDNUT23$__"